import { t } from '@/libs/i18n'

export const CONFIG = {
  blank: {
    side_panel: {
      fixed: true,
      content: (props = {}) => {
        return {
          title: t('slides_editor.toolbar.choose_layout'),
          component: 'LayoutForm',
          props: { ...props }
        }
      }
    }
  },
  default: {
    side_panel: {
      fixed: false
    }
  },
  section: {
    side_panel: {
      fixed: true,
      content: (props = {}) => {
        return {
          title: t('slides_editor.components.question_form.add_question'),
          component: 'VariantPicker',
          props: { ...props }
        }
      }
    }
  },
  spark: {
    side_panel: {
      fixed: true,
      content: (props = {}) => {
        const block = props.slide.blocks.find(block => block.has_spark)

        if (block) {
          return {
            title: t('slides_editor.components.spark_form.edit_spark'),
            component: 'SparkForm',
            props: { block }
          }
        }

        return {
          title: t('slides_editor.components.question_form.add_question'),
          component: 'VariantPicker',
          props: { ...props }
        }
      }
    },
  }
}
